import React, { memo } from 'react'

/**
 * The stats that used to live in the Stats table, as a per player list:
 * max vills, max trade, max fish, eco killed, apm and relics.
 * Trade / fish / relics only show up on the side of a player that has any,
 * so one player can show Max Fish while the other does not.
 * The player with the higher value of a stat gets a star.
 */
const PlayerStats = memo(({ summary, extraInfo = {}, index = 0, side = 'left', className = '' }) => {
	const players = summary?.players
	if (players?.length !== 2) return null

	const player = players[index]
	const opponent = players[(index + 1) % 2]

	const relics = index ? extraInfo.rightRelics : extraInfo.leftRelics
	const opponentRelics = index ? extraInfo.leftRelics : extraInfo.rightRelics

	const stats = [
		{ key: 'maxVillagers', label: 'Max Vills', value: player.maxVillagers, other: opponent.maxVillagers },
		{ key: 'maxTraders', label: 'Max Trade', value: player.maxTraders, other: opponent.maxTraders, show: !!player.maxTraders },
		{ key: 'maxFishingShips', label: 'Max Fish', value: player.maxFishingShips, other: opponent.maxFishingShips, show: !!player.maxFishingShips },
		// eco killed is the eco the *other* player lost
		{ key: 'economyKilled', label: 'ECO Killed', value: opponent.economyLost, other: player.economyLost },
		{ key: 'apm', label: 'APM', value: player.apm, other: opponent.apm },
		{ key: 'relics', label: 'Relics', value: relics, other: opponentRelics, show: !!relics },
	].filter((stat) => stat.show !== false)

	return (
		<div className={`playerStats playerStats--${side} ${className}`.trim()}>
			{stats.map((stat) => (
				<div key={stat.key} className={`playerStats__item playerStats__item--${stat.key}`}>
					<div className="playerStats__label">{stat.label}</div>
					<div className="playerStats__value">
						{stat.value ?? 0}
						{stat.value > stat.other && <span className="playerStats__star">⭐</span>}
					</div>
				</div>
			))}
		</div>
	)
})

export { PlayerStats }
